import { render, staticRenderFns } from "./EditarEvento.vue?vue&type=template&id=f25c5434&scoped=true&lang=pug&"
import script from "./EditarEvento.vue?vue&type=script&lang=js&"
export * from "./EditarEvento.vue?vue&type=script&lang=js&"
import style0 from "./EditarEvento.vue?vue&type=style&index=0&id=f25c5434&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25c5434",
  null
  
)

export default component.exports